/** ID de la tarea padre; null si es raíz */
export function getSupportTicketParentId(ticket) {
  const p = ticket?.parent_task?.id ?? ticket?.parent_task_id;
  if (p == null || p === '') return null;
  const n = Number(p);
  return Number.isFinite(n) ? n : null;
}

/** parent_id desde hierarchy_display / etiqueta tipo "9.1" (sin depender de parent_task_id en JSON). */
export function getHierarchyParentIdFromLabel(ticket, ticketsInView) {
  const hd =
    ticket?.hierarchy_display != null ? String(ticket.hierarchy_display).trim() : '';
  if (hd.includes('.')) {
    const n = Number(hd.split('.')[0]);
    if (Number.isFinite(n) && n > 0) return n;
  }
  const badge = getChildHierarchyBadgeLabel(ticket, ticketsInView);
  if (badge != null && String(badge).includes('.')) {
    const n = Number(String(badge).split('.')[0]);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return null;
}

/** Hija de un padre: parent_task_id, parent_task.id o referencia visual 9.1 */
export function ticketBelongsToHierarchyParent(ticket, parentId, ticketsInView = []) {
  const pid = Number(parentId);
  if (!Number.isFinite(pid) || pid <= 0 || !ticket) return false;
  if (Number(ticket.id) === pid) return true;
  if (getSupportTicketParentId(ticket) === pid) return true;
  return getHierarchyParentIdFromLabel(ticket, ticketsInView) === pid;
}

/**
 * Etiqueta tipo "3.1" para hijas: hierarchy_display del API o cálculo entre hermanas en lista.
 */
export function getChildHierarchyBadgeLabel(ticket, ticketsInView) {
  const parentId = getSupportTicketParentId(ticket);
  if (parentId == null) return null;

  const raw = ticket?.hierarchy_display;
  if (raw != null && String(raw).trim().includes('.')) {
    return String(raw).trim();
  }

  if (!Array.isArray(ticketsInView) || ticketsInView.length === 0) return null;
  const siblings = ticketsInView
    .filter((t) => getSupportTicketParentId(t) === parentId)
    .sort((a, b) => Number(a.id) - Number(b.id));
  const idx = siblings.findIndex((t) => Number(t.id) === Number(ticket.id));
  if (idx < 0) return null;
  return `${parentId}.${idx + 1}`;
}

/** Filtro por ID numérico, referencia jerárquica (3.1) o ticket Arranda frente a lista cargada. */
export function ticketMatchesSearchId(ticket, searchId, ticketsInView) {
  if (searchId == null || String(searchId).trim() === '') return true;
  const s = String(searchId).trim().replace(/^#+/, '');
  if (!s) return true;
  if (ticket.id != null && String(ticket.id) === s) return true;
  if (/^\d+$/.test(s)) {
    const arrId = ticket.arranda_ticket_id ?? ticket.arranda_ticket?.id;
    if (arrId != null && String(arrId) === s) return true;
  }
  if (/^\d+\.\d+$/.test(s)) {
    const label = getChildHierarchyBadgeLabel(ticket, ticketsInView);
    if (label === s) return true;
    const hd = ticket.hierarchy_display != null ? String(ticket.hierarchy_display).trim() : '';
    if (hd === s) return true;
    const title = (ticket.title || '').trim();
    if (title === s || title.startsWith(`${s} ·`) || title.startsWith(`${s} `)) return true;
  }
  const q = s.toLowerCase();
  const arrName = String(ticket.arranda_ticket?.ticket_name ?? '').toLowerCase();
  if (arrName && arrName.includes(q)) return true;
  const hdLower = String(ticket.hierarchy_display ?? '').toLowerCase();
  if (hdLower && hdLower.includes(q)) return true;
  const hier = String(getChildHierarchyBadgeLabel(ticket, ticketsInView) ?? '').toLowerCase();
  if (hier && hier.includes(q)) return true;
  return false;
}
